// extracted by mini-css-extract-plugin
export default {"background-section":"Head_background-section__i3vgB","main":"Head_main__eu61J","div":"Head_div__pSjpN","scroll-up":"Head_scroll-up__ZEAjJ"};